import { render, staticRenderFns } from "./FastCheckDocument.vue?vue&type=template&id=0b6a2b8e&"
import script from "./FastCheckDocument.vue?vue&type=script&lang=js&"
export * from "./FastCheckDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports